<template>
	<div class="tab-text">
		<div class="w-full flex flex-wrap">
			<div class="w-full lg:w-1/2 sm:w-1/1 pr-4">
				<h3 class="mb-8">Matching Factor</h3>
				<vue-apex-charts
					type="radialBar"
					height="300"
					:options="chartOptions"
					class="matching-apexcharts"
					:series="[result.matchingScore]"
				/>
			</div>
			<div class="w-full lg:w-1/2 sm:w-1/1 pr-4">
				<vx-card class="h-100">
					<div class="">
						<div class="flex justify-between">
							<div class="flex flex-col">
								<span class="mb-1">Destination</span>
							</div>
							<div class="flex flex-col text-right">
								<h4>100%</h4>
							</div>
						</div>
						<vs-progress :percent="100"></vs-progress>
					</div>
					<div class="mt-4">
						<div class="flex justify-between">
							<div class="flex flex-col">
								<span class="mb-1">Departure Time</span>
							</div>
							<div class="flex flex-col text-right">
								<h4>100%</h4>
							</div>
						</div>
						<vs-progress :percent="100"></vs-progress>
					</div>
					<div class="mt-4">
						<div class="flex justify-between">
							<div class="flex flex-col">
								<span class="mb-1">Budget</span>
							</div>
							<div class="flex flex-col text-right">
								<h4>100%</h4>
							</div>
						</div>
						<vs-progress :percent="100"></vs-progress>
					</div>
					<div class="mt-4">
						<div class="flex justify-between">
							<div class="flex flex-col">
								<span class="mb-1">Duration</span>
							</div>
							<div class="flex flex-col text-right">
								<h4>100%</h4>
							</div>
						</div>
						<vs-progress :percent="100"></vs-progress>
					</div>
					<div class="mt-4">
						<div class="flex justify-between">
							<div class="flex flex-col">
								<span class="mb-1">Cruise Line</span>
							</div>
							<div class="flex flex-col text-right">
								<h4>100%</h4>
							</div>
						</div>
						<vs-progress :percent="100"></vs-progress>
					</div>
					<div class="mt-4">
						<div class="flex justify-between">
							<div class="flex flex-col">
								<span class="mb-1">Service</span>
							</div>
							<div class="flex flex-col text-right">
								<h4>{{ serviceScore }}%</h4>
								<span class="text-grey text-sm"
									>(service is in the top percentile of service ratings over all
									ships)</span
								>
							</div>
						</div>
						<vs-progress :percent="serviceScore"></vs-progress>
					</div>
					<div class="mt-4">
						<div class="flex justify-between">
							<div class="flex flex-col">
								<span class="mb-1">Food & Beverage</span>
							</div>
							<div class="flex flex-col text-right">
								<h4>90%</h4>
								<span class="text-grey text-sm"
									>(F&B is in the top 2 percentile of service ratings over all
									ships)</span
								>
							</div>
						</div>
						<vs-progress :percent="90"></vs-progress>
					</div>
				</vx-card>
			</div>
		</div>
	</div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";

export default {
	components: {
		VueApexCharts,
	},
	data() {
		return {
			chartOptions: {
				plotOptions: {
					radialBar: {
						size: 110,
						startAngle: -150,
						endAngle: 150,
						hollow: { size: "77%" },
						track: { background: "#bfc5cc", strokeWidth: "50%" },
						dataLabels: {
							name: { show: false },
							value: { offsetY: 18, color: "#99a2ac", fontSize: "4rem" },
						},
					},
				},
				colors: ["#e44a7f"],
				fill: {
					type: "gradient",
					gradient: {
						shade: "dark",
						type: "horizontal",
						shadeIntensity: 0.5,
						gradientToColors: ["#e44a7f"],
						inverseColors: true,
						opacityFrom: 1,
						opacityTo: 1,
						stops: [0, 100],
					},
				},
				stroke: { lineCap: "round" },
				chart: {
					sparkline: { enabled: true },
					dropShadow: { enabled: true, blur: 3, left: 1, top: 1, opacity: 0.1 },
				},
			},
		};
	},
	props: {
		result: {
			type: Object,
			required: true,
		},
  },
  computed: {
    serviceScore() {
      if (this.result.shipName == 'Ovation of the Seas') {
        return 94;
      } else {
        return 100;
      }
    }
  }
};
</script>
